// extracted by mini-css-extract-plugin
export default {"container":"RemoveContainer_container__Rb2d3","field":"RemoveContainer_field__ZeMM4","removeContainer":"RemoveContainer_removeContainer__CsVJ6"};